import AlbumFolderPurchasePrintPackages from './DiscoverAlbumFolderPrintPackages';

export default AlbumFolderPurchasePrintPackages;
